<template>
  <div class="home">
    <TheHeader />
    <button class="mobile-nav-toggle" @click="navOpen = !navOpen">
      {{ navOpen ? `Menü ausblenden (${currentMenuLabel})` : `Menü anzeigen (${currentMenuLabel})` }}
    </button>
    <nav :class="{ 'mobile-hidden': !navOpen }">
      <router-link to="/home" activeClass="active">Dienstplan</router-link>
      <router-link to="/coredata">Stammdaten</router-link>
      <button @click="logout">Logout</button>
    </nav>

    <router-view></router-view>

    <TheFooter />
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { computed, ref } from "vue";
import TheFooter from "@/components/TheFooter.vue";
import TheHeader from "@/components/TheHeader.vue";
const store = useStore();
const router = useRouter();
const route = useRoute();
const navOpen = ref(false);
const currentMenuLabel = computed(() => {
  if (route.path === "/coredata") return "Stammdaten";
  return "Dienstplan";
});
function logout() {
  store.dispatch("auth/logout").then(router.push("/"));
}
</script>
<style scoped>
.home {
  padding-bottom: 96px;
  height: 90%;
}

@media (max-width: 1023px) {
  .home {
    padding-bottom: 170px;
  }
}

@media (min-width: 421px) {
  .mobile-nav-toggle {
    display: none;
  }
}
</style>
